import { render, staticRenderFns } from "./agentBookingTx.vue?vue&type=template&id=65df4f4b&scoped=true"
import script from "./agentBookingTx.vue?vue&type=script&lang=js"
export * from "./agentBookingTx.vue?vue&type=script&lang=js"
import style0 from "./agentBookingTx.vue?vue&type=style&index=0&id=65df4f4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65df4f4b",
  null
  
)

export default component.exports